<template>
  <section class="td-consolusion" :style="box" v-if="textarea">
    <div :class="container">
      <div class="td-consolusion__content">
        <h2 class="h2">{{title}}</h2>
        <p v-if="!!textarea">{{textarea}}</p>
      </div>

      <div class="td-consolusion__bottom">

        <div class="td-consolusion__col" v-if="!!facebook">
          <FacebookButton> 
            Deila
          </FacebookButton>
        </div>

        <div class="td-consolusion__col">
          <span v-if="!!price" class="td-consolusion__price">
            Verð frá {{price}} kr.
          </span>
          <a v-if="!!defaultButton" :href="defaultButton" class="td__btn-primary">
            <span>Skoða verðlistann</span>
          </a>
        </div>
      </div>
    </div>

    <!-- <div class="container-middle" v-if="!!isCar && post.id && car.brands.length">
      <TableOtherModels :car="car" :id="post.id + ''"/>
    </div>

    <div class="container-middle" v-if="post.api === 1">
      <AmountCarsAvailable
        :propLogo="'https://uploads-ssl.webflow.com/5d7552387a6dfaca8c256678/5d7643b98b433514d3f6cdf7_bilablogg_logo.png'"
        :propBrand="'Bilablogg.is er samstafsaðili Bilaskra.is'"
        :propCompanyAddress="'Við reynsluökum bílum, tökum viðtöl, skrifum greinar og fjöllum um bíla á óhlutdrægan hátt. Umferð, öryggi, vegir, tryggingamál og allt annað sem tengist bílum og umferð.'"
        :propLinkHref="'https://www.bilablogg.is/'"
        :propLinkText="'www.bilablogg.is'"
        :loaded="post"
      />
    </div> -->
  </section>
</template>

<script>
import axios from 'axios'
import mixin from '@/mixins/sections/styleSettings'
//import TableOtherModels from '@/components/Dealers/TableOtherModels'
import facebookShare from '@/helpers/facebookShare'

import FacebookButton from '@/components/FacebookButton'
//import AmountCarsAvailable from "@/components/Dealers/AmountCarsAvailable"

import { mapState } from 'vuex'
export default {
  mixins: [mixin],
  components: {
    //TableOtherModels,
    FacebookButton,
    //AmountCarsAvailable
  },
  data: () => ({
    //car: null,
    dialog: null
  }),
  methods: {
    /* getCarInfo() {
      const api = this.$store.state.api;
      axios.get(`${api}/new-cars/get-car?id=${this.post.car_id}`)
        .then((res) => this.car = res.data)
        .catch((err) => console.log('err', err))
    }, */

    shareFb() {
      this.dialog = facebookShare()
    }
  },
  computed: {
    ...mapState('blog', {
      post: state => state.simplePage
    }),

    // hasData to be in mixin
    title() {
      return this.hasData.title
        ? this.hasData.title
        : 'Lokaorð'
    },
    /* isCar() {
      return this.post && this.post.car_id
    }, */

    textarea() {
      return this.hasData && this.hasData.textarea
    },
    hasLinks() {
      return this.hasData && this.hasData.links && this.hasData.links
    },
    facebook() {
      return this.hasLinks.facebook.link
    },
    defaultButton() {
      return this.hasLinks.default.link
    },
    price() {
      return this.hasData && this.hasData.price
    }
  },
  /* created() {
    if(this.isCar)
      this.getCarInfo()
  }, */
  destroyed() {
    if (this.dialog)
      this.dialog.close()
  }
}
</script>
